import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@app/store/types';

export const getEditingDocumentsState = (state: RootState) => state.editingDocuments;

export const getTotalCount = (state: RootState) => getEditingDocumentsState(state).totalCount;
export const getById = (state: RootState) => getEditingDocumentsState(state).byId;
export const getItems = (state: RootState) => getEditingDocumentsState(state).items;
export const getContractEditingDocumentItems = createSelector(getItems, getById, (items, byId) =>
  items.map((id) => byId[id])
);

export const getErrorWhileDeleting = (state: RootState) =>
  getEditingDocumentsState(state).errorWhileDeleting;
export const getErrorWhileListFetching = (state: RootState) =>
  getEditingDocumentsState(state).errorWhileListFetching;
export const isDeleting = (state: RootState) => getEditingDocumentsState(state).isDeleting;
export const isFetched = (state: RootState) => getEditingDocumentsState(state).isFetched;
export const isListFetching = (state: RootState) => getEditingDocumentsState(state).isListFetching;

export const getLimit = (state: RootState) => getEditingDocumentsState(state).limit;
export const getOffset = (state: RootState) => getEditingDocumentsState(state).offset;
export const getSearchKeyword = (state: RootState) => getEditingDocumentsState(state).searchKeyword;
export const getMemberId = (state: RootState) => getEditingDocumentsState(state).memberId;
export const getAllFilters = createSelector(
  getLimit,
  getOffset,
  getSearchKeyword,
  getMemberId,
  (limit, offset, searchKeyword, memberId) => ({ limit, offset, searchKeyword, memberId })
);
